/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".room-schedule-table[_ngcontent-%COMP%]{border:none}.room-schedule-table[_ngcontent-%COMP%]   tbody[_ngcontent-%COMP%]{font-size:smaller}.room-schedule-table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{border-width:0 1px 0 0;height:2rem;position:relative}.room-schedule-table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]:last-child, .room-schedule-table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{border:none}.room-schedule-table[_ngcontent-%COMP%]   .sat[_ngcontent-%COMP%]{background-color:rgba(0,0,0,.1)}"];
export { styles as styles };
